<template>
    <div class="relative">
        <Handle
            v-for="position in positions"
            :key="position"
            type="target"
            :id="position"
            :position="position"
            class="absolute opacity-0"
            :style="handleStyle(position)"
        />

        <div
            class="w-24 h-24 shadow-lg border-2 hover:border-blue-500 transition-all duration-150 rounded-lg"
            :class="{'border-blue-500': props.isHover, 'border-white': !props.isHover}"
        >
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 56 56" xml:space="preserve" id="nodeElement">
                <path fill="#FFFFFF" d="M4,0h48c2.2,0,4,1.8,4,4v48c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V4C0,1.8,1.8,0,4,0z"></path>
                    <g transform="translate(2626.583 -40)">
                        <g transform="translate(-3200.492 306.9)">
                            <path fill="#CFD8DC" d="M616.9-244.8v21.9c0,1.1-0.9,2-2,2h-22c-1.1,0-2-0.9-2-2v-32c0-1.1,0.9-2,2-2h12L616.9-244.8z"></path>
                        </g>
                        <g transform="translate(-3200.492 306.9)">
                            <path fill="#90A4AE" d="M615.9-245.8l1,1h-10c-1.1,0-2-0.9-2-2v-10.1l0.9,0.9l1,1l8.1,8.1L615.9-245.8z"></path>
                        </g>
                        <g transform="translate(-3200.492 306.9)">
                            <path fill="#23A566" d="M587.9-243.9h14c1.1,0,2,0.9,2,2v14c0,1.1-0.9,2-2,2h-14c-1.1,0-2-0.9-2-2v-14 C585.9-243,586.8-243.9,587.9-243.9z"></path>
                        </g>
                        <g transform="translate(-3200.492 306.9)">
                            <path fill="#FFFFFF" d="M600.1-235.4v-1.6h-5.7v-3.1h-1.6v3.1h-3.1v1.6h3.1v5.7h1.6v-5.7H600.1"></path>
                        </g>
                    </g>
            </svg>
        </div>
        <span :title="label" class="absolute">
            {{ props.label }}
        </span>
    </div>

</template>

<script setup>
import { Position } from '@vue-flow/core'
import { Handle } from '@vue-flow/core'
import {defineProps} from 'vue'

const props = defineProps({
    label: String,
    isHover: { type: Boolean, default: false },

})

const positions = [Position.Top, Position.Left, Position.Right, Position.Bottom]

const handleStyle = (position) => {
    const size = 0 // размер хендла
    const offset = -size / 2 // смещение для точного позиционирования

    switch(position) {
        case Position.Top: return { top: `${offset}px`, left: '50%', transform: 'translateX(-50%)' }
        case Position.Left: return { left: `${offset}px`, top: '50%', transform: 'translateY(-50%)' }
        case Position.Right: return { right: `${offset}px`, top: '50%', transform: 'translateY(-50%)' }
        case Position.Bottom: return { bottom: `${offset}px`, left: '50%', transform: 'translateX(-50%)' }
    }
}
</script>
